module.exports = __webpack_public_path__ + "download.84f03974dc7c351f2e951f0e79289e1c.svg";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar/img/download.svg
// module id = 1657
// module chunks = 39